import { render, staticRenderFns } from "./CiFilters.vue?vue&type=template&id=3220cfa8&"
import script from "./CiFilters.vue?vue&type=script&lang=js&"
export * from "./CiFilters.vue?vue&type=script&lang=js&"
import style0 from "./CiFilters.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports